import { COMPANY_REVIEWS } from "@shared/companyFacts";
import { Award, Star, Shield, Factory } from "lucide-react";
import { StaggerContainer, StaggerItem } from "@/components/ScrollAnimations";

const trustItems = [
  {
    icon: Star,
    label: COMPANY_REVIEWS.ratingLabel,
    sublabel: COMPANY_REVIEWS.countLabel,
  },
  { icon: Award, label: "Sedan 2012", sublabel: "Erfarenhet av inglasningar" },
  { icon: Shield, label: "Cirka 18 000", sublabel: "Inglasade balkonger" },
  { icon: Factory, label: "Egen produktion", sublabel: "Tillverkat i Sverige" },
];

export default function TrustBar() {
  return (
    <div className="bg-white border-y border-border/50">
      <div className="container py-3 sm:py-4 lg:py-5">
        <StaggerContainer
          className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-8"
          staggerDelay={0.08}
        >
          {trustItems.map(item => (
            <StaggerItem key={item.label}>
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-sand flex items-center justify-center shrink-0">
                  <item.icon className="w-4 h-4 sm:w-5 sm:h-5 text-navy" />
                </div>
                <div className="min-w-0">
                  <div className="font-heading font-bold text-navy text-xs sm:text-sm truncate">
                    {item.label}
                  </div>
                  <div className="text-[0.65rem] sm:text-xs text-muted-foreground truncate">
                    {item.sublabel}
                  </div>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </div>
  );
}
